import React, { useState } from "react";
import { Modal, Upload, Input, DatePicker, Select } from "antd";
import { Icon } from "@iconify/react";
import Button from "../components/shared/button";
import Input_Field from "../components/shared/input";
import { uploadClientData, saveClientData } from "../APIs/clientApis";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";

const { Dragger } = Upload;
const { Option } = Select;

const AddNewModal = ({ isaddnewModelOpen, setisaddnewModelOpen }) => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploadedFileUrl, setUploadedFileUrl] = useState("");
  const [formData, setFormData] = useState({
    caseType: "",
    caseID: "",
    title: "",
    courtDate: null,
    description: "",
  });

  const cases = ["Medical", "Marriage", "Land", "Other"];

  const handleOk = () => {
    setisaddnewModelOpen(false);
  };

  const handleUploadChange = async ({ fileList }) => {
    setFileList(fileList);

    if (fileList.length > 0) {
      setIsUploaded(true);

      //  Upload file to backend AI model
      const file = fileList[0].originFileObj;
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await uploadClientData(formData);
        console.log("AI Model Response:", response);

        //  Autofill fields if AI extracts data
        setFormData({
          caseType: response.caseType || "",
          caseID: response.data.analysis.ID_No || "",
          title: response.data?.analysis?.notes || "",
          courtDate: response.data?.analysis?.upload_date
            ? response.data?.analysis?.upload_date
            : null,
          description: response.description || "",
        });
        setUploadedFileUrl(response?.data?.document_url);
      } catch (error) {
        console.error("File upload error:", error);
      }
    } else {
      setIsUploaded(false);
    }
  };

  console.log(formData);
  //  Handle Save Button Click
  const handleSave = async () => {
    try {
      if (!uploadedFileUrl) {
        console.error("No document uploaded");
        return;
      }

      const caseID = formData.caseID ? formData.caseID.toString() : "";

      const formattedData = {
        id_no: uuidv4(), // Generates a unique ID
        case_id: caseID,
        upload_date: formData.courtDate,
        document_name: formData.title || "Untitled Document",
        notes: formData.description || "No notes provided",
        billing_fees: formData.billingFees || "N/A",
        lawyer_notes: formData.lawyerNotes || "N/A",
        document_url: uploadedFileUrl || "", // This should be set after file upload
      };

      console.log("Final Request Data:", formattedData);

      const response = await saveClientData(formattedData);
      console.log("Save Response:", response);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Function to reset modal state
  const handleCancel = () => {
    setisaddnewModelOpen(false);
    setIsUploaded(false);
    setFileList([]);
    setFormData({
      title: "",
      description: "",
      caseID: "",
      courtDate: null,
    });
  };

  // const handleCancel = () => {
  //   setisaddnewModelOpen(false);
  //   setIsUploaded(false); // Reset state when modal closes
  //   setFileList([]);
  // };

  // const handleUploadChange = ({ fileList }) => {
  //   setFileList(fileList);
  //   if (fileList.length > 0) {
  //     setIsUploaded(true);
  //   } else {
  //     setIsUploaded(false);
  //   }
  // };

  const handleRemoveFile = () => {
    setFileList([]);
    setIsUploaded(false); // Show the upload dragger again
  };

  return (
    <Modal
      open={isaddnewModelOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="del-modal"
      centered={true}
      width="65%"
    >
      <div className="modal-content rounded-[19px] w-full max-w-full overflow-y-auto min-h-[90vh] flex flex-col justify-between items-center py-[22px] px-[50px] max-sm:px-[20px]">
        <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
          Add Document
        </h5>

        {isUploaded ? (
          <div className="form-view w-full flex flex-col mt-[14px] items-center space-y-[21px]">
            <div className="uploaded-file-preview pt-[19px] pb-[32px] px-[19px] flex flex-col items-center justify-between border-dashed border-[#999999] border-2 max-w-[327px] w-full rounded-[17px]">
              <div className="relative">
                <img src="../../assets/images/dashboard/fileImg.png" alt="" />
                <Icon
                  icon="mdi:cross-circle"
                  width={22}
                  height={22}
                  color="#143A62"
                  onClick={handleRemoveFile}
                  className="cursor-pointer absolute top-[-4%] right-[-4%]"
                />
              </div>
              <p className="e-small font-semibold text-[#999] mt-[3px]">
                {fileList[0].name}
              </p>
            </div>
          </div>
        ) : (
          // Display upload dragger initially
          <Dragger
            name="file"
            multiple={false}
            fileList={fileList}
            onChange={handleUploadChange}
            beforeUpload={() => false} // Prevent auto-upload
            className="upload-div w-full mt-[14px] max-w-[526px] h-[226px] border-dashed border-[#999999] border-2 flex flex-col items-center justify-center rounded-[17px]"
          >
            <Icon
              icon="material-symbols:upload"
              width={60}
              height={60}
              color="#999999"
              className="m-auto"
            />
            <p className="medium text-[#999] font-semibold">Upload file</p>
            <p className="text-[#999] font-semibold e-small">
              Filetype: PDF, DOCX, PPT
            </p>
          </Dragger>
        )}
        <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
          <div className="w-full select-case-drop">
            <p className="text-blue font-medium font-manrope medium">
              Select Case
            </p>
            <Select
              placeholder="Case Management"
              className="reminder-case w-full mt-[6px] rounded-[10px] bg-white border-none"
              onChange={(value) =>
                setFormData({ ...formData, caseType: value })
              }
            >
              {cases.map((caseItem, index) => (
                <Option key={index} value={caseItem}>
                  {caseItem}
                </Option>
              ))}
            </Select>
          </div>
          <Input_Field
            label="Associated Case ID"
            type="text"
            name="caseID"
            value={formData.caseID}
            placeholder="#6541"
            className="dash-input-field"
            wrapperClass="dash-wrapper"
            labelClass="dash-label"
            onChange={handleChange}
          />
        </div>

        <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
          <Input_Field
            label="Title"
            type="text"
            name="title"
            placeholder="Title"
            className="dash-input-field"
            wrapperClass="dash-wrapper"
            labelClass="dash-label"
            value={formData.title}
            onChange={handleChange}
          />
          <div className="w-full">
            <p className="text-blue font-medium font-manrope medium">
              Deadline/Court Date
            </p>
            <DatePicker
              value={
                formData?.courtDate
                  ? dayjs(formData.courtDate, "YYYY-MM-DD")
                  : null
              }
              className="w-full mt-[6px]"
              format="YYYY-MM-DD"
              onChange={(date, dateString) =>
                setFormData({ ...formData, courtDate: dateString })
              }
            />
          </div>
        </div>

        <div className="w-full mt-[14px]">
          <p className="text-blue font-medium font-manrope medium">
            Description
          </p>
          <Input.TextArea
            placeholder="Type"
            rows={5}
            className="mt-[6px]"
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>
        <Button
          text="Save"
          className="button btn-blue !rounded-[39px] large mt-[14px]"
          height={45}
          width={176}
          // onClick={handleCancel}
          onClick={handleSave}
        />
      </div>
    </Modal>
  );
};

export default AddNewModal;
